import { Box, Typography } from "@mui/material"


const RedemptionPage: React.FC = () => {
    return (
        <Box height="100vh" bgcolor="#FFFFFF">
            <Typography variant='h4' color='textPrimary'>Resgates</Typography>
            <Typography variant="subtitle1" color="textSecondary">Aqui você pode acompanhar todos os resgates realizados</Typography>
        </Box>
    )
}

export default RedemptionPage